import {AfterViewInit, Component, Input, OnDestroy, OnInit} from '@angular/core';
import {ParkInterface} from '@app/app/shared/interfaces/park.interface';
import {ParksService} from '@app/app/shared/services/parks.service';
import {AuthenticationService} from '@app/app/shared/services/authentication.service';
import {HttpClient} from '@angular/common/http';
import {environment} from '@app/environments/environment';
import {UrlHelper} from '@app/app/shared/helpers/url.helper';
import {AWSService} from '@app/app/shared/services/aws.service';
import {Subscription} from 'rxjs/Subscription';

@Component({
  templateUrl: './park-settings.html',
  selector: 'park-settings'
})
export class ParkSettingsComponent implements OnInit {
  @Input() park: ParkInterface;
  public isEditMode: false;
  public isEditInfoMode: false;
  public isEditLedMode: false;
  public isEditNotifications: false;
  public notificationSettings;
  public isEditTimeMode: false;

  constructor(private aws: AWSService, private urlHelper: UrlHelper, private http: HttpClient) {
    //
  }

  getNotifications() {
    this.http.get(`${this.urlHelper.getPrefix()}/parks/${this.park.id}/notifications`).subscribe((res: any) => {
      this.notificationSettings = res.data;
    }, (err) => {
      console.log(err);
    });
  }

  ngOnInit() {
    const commandId: string = Math.random().toString(36).substring(2, 15) + Math.random().toString(36).substring(2, 15);

    const data = {
      jsonrpc: environment.jsonrpcVersion,
      method: 'meta',
      params: {},
      id: commandId
    };

    const topic = `${this.park.attributes.parkId}/commands/${commandId}`;

    this.aws.connect2().subscribe(conn => {
      conn.publish(topic, JSON.stringify(data), {qos: 1});
    });

    this.getNotifications();
  }
}



// WEBPACK FOOTER //
// ./src/app/dashboard/parks/park/settings/park-settings.component.ts